import React, { useState, useEffect } from 'react';
import HistoryTable from './HistoryTable';
import Tab from '../CustomTab';
import TabPane from '../CustomTab/TabPane';
import { HISTORY_TABS } from './enum';
import { getLabel } from '../../utils/i18n';
import { fetchLendingAssets } from '../../actions/actionsSet/lending';

type Props = {
  i18n: Object,
  locale: string,
}

const History = ({
  i18n, locale,
}: Props) => {
  const [coinList, setCoinList] = useState([{
    key: '',
    label: getLabel('exchange-common-all', i18n),
  }]);
  useEffect(() => {
    async function fetchCoinList() {
      const rs = await fetchLendingAssets();
      setCoinList(assets => ([
        ...assets,
        ...rs.map(({ asset }) => ({
          key: asset,
          label: asset,
        })),
      ]));
    }
    fetchCoinList();
  }, []);
  return (
    <Tab defaultActiveKey="Subscription">
      {
      HISTORY_TABS.map(({ label, key }) => (
        <TabPane key={key} tab={getLabel(label, i18n)}>
          <HistoryTable
            i18n={i18n}
            locale={locale}
            coinList={coinList}
            type={key}
          />
        </TabPane>
      ))
    }
    </Tab>
  );
};

export default History;
